module.exports = __webpack_public_path__ + "img/key_features--opticare_x.1ff75830.jpg";